
import { environment } from '../environments/environment';
export const AppSettings = {
  EMAIL_API_ENDPOINT:environment.email_host+'/api',
  API_ENDPOINT:environment.call_host+'/speech-recognition',
  EXCEL_ENDPOINT:environment.excel_host+'/rfp',
  BASE_LOGIN:environment.base_login,
  csrfCookieName: environment.csrfCookieName
}